import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { ReturnReasonState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/return-reason";
import { BadgeRedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoTagsDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-tags-dropdown-input";
import { memo, useContext, useMemo } from "react";
import { FlowOptionsContext } from "../condition";
import { getReasonOptionsForReturnReasonCondition } from "./return-reason-options";

export const ReturnReasonDetails = memo(function ReturnReasonDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<ReturnReasonState>) {
  const flowOptions = useContext(FlowOptionsContext);

  const options: BadgeRedoListItem<string>[] = useMemo(() => {
    const reasonOptions = flowOptions
      ? getReasonOptionsForReturnReasonCondition({
          claimReasonOptions: flowOptions.claimReasonOptions,
          conditionName: flowOptions.returnReasonConditionName,
          returnReasonOptions: flowOptions.returnReasonOptions,
          warrantyReasonOptions: flowOptions.warrantyReasonOptions,
        })
      : [];
    return reasonOptions.map((reason) => ({
      type: "badge" as const,
      id: reason,
      value: reason,
      badge: { text: reason, color: "gray" as const },
    }));
  }, [flowOptions]);

  const selectedOptions: BadgeRedoListItem<string>[] = useMemo(() => {
    return state.map((reason) => ({
      type: "badge" as const,
      id: reason,
      value: reason,
      badge: { text: reason, color: "gray" as const },
    }));
  }, [state]);

  const label = flowOptions?.returnReasonConditionName ?? "Return reason";
  const pluralLabel = `${label}s`;

  return (
    <RedoTagsDropdownInput
      description={`Condition applies to the return item if any of the selected ${pluralLabel.toLowerCase()} are chosen.`}
      disabled={disabled}
      label={pluralLabel}
      options={options}
      placeholder={`Select ${pluralLabel.toLowerCase()}...`}
      selectedOptions={selectedOptions}
      setSelectedOptions={(items) => {
        setState(items.map((item) => item.value));
      }}
      size="xs"
    />
  );
});
